var requestedProducts = [
    { "label": "سمپل", value: 0 },
    { "label": "تایل", value: 1 },
    { "label": "استند", value: 2 },
    { "label": "سمپل بوک", value: 3 },
];

export default requestedProducts;
